import { z } from "zod";

export const CustomerInfoSchema = z.object({
  firstName: z.string().trim().min(1, "First name is required"),
  lastName: z.string().trim().min(1, "Last name is required"),
  email: z
    .string()
    .trim()
    .min(1, "Email is required")
    .email("Email is invalid"),
  phone: z.string(),
});

export type CustomerInfoFormData = z.infer<typeof CustomerInfoSchema>;
